"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SuccessIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function SuccessIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Alert/Success/Action",
    transform: "translate(-16.000000, -18.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Danger-alert-(action)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Alert"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Action-/-done"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "ic_done"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Bounds",
    points: "0 0 25 0 25 25 0 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Icon",
    fill: "#FFFFFF",
    points: "9.375 16.875 5 12.5 3.54166667 13.9583333 9.375 19.7916667 21.875 7.29166667 20.4166667 5.83333333"
  })))))))));
}